<template>
  <div class="text-left">
    <b-overlay :show="loading" rounded="sm">
      <form id="loginForm" class="form-horizontal" accept-charset="utf-8" @submit.prevent="onSubmit()">
        <b-form-group id="input-group-1" label="Email" label-for="email" description="">
          <b-form-input
            id="email"
            name="email"
            maxlength="100"
            v-model="user.email"
            type="text"
            size="sm"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-1" label="Password" label-for="password" description="">
          <b-form-input
            size="sm"
            id="password"
            name="password"
            maxlength="100"
            v-model="user.password"
            type="password"
            required
          ></b-form-input>
        </b-form-group>
        <b-row>
          <b-col cols="6">
            <b-button pill size="sm" variant="primary" id="loginSubmitBtn" type="submit">Accedi</b-button>
          </b-col>
          <b-col lg="6">
            <div class="form-check form-check-inline">
              <input type="hidden" name="remember" id="remember_" value="0" v-model="user.remember" />
              <input
                type="checkbox"
                name="remember"
                value="1"
                id="remember"
                checked="checked"
                class="form-check-input"
              />
              <label class="form-check-label text-danger" for="remember"
                ><small><strong>Remember me</strong></small></label
              >
            </div>
          </b-col>
          <b-col cols="12" class="mt-2">
            <b-alert :show="message != ''">{{ message }}</b-alert>
            <router-link to="/users/reset-password"><small>Ho dimenticato la password</small> </router-link>
          </b-col>
        </b-row>
      </form>
    </b-overlay>
  </div>
</template>
<script>
import User from "@/models/user";

export default {
  name: "Login",
  data() {
    return {
      user: new User("", ""),
      loading: false,
      message: "",
      myRoot: process.env.VUE_APP_ROOT,
      userType: this.$route.params.userType,
    };
  },
  methods: {
    onSubmit() {
      this.loading = true;

      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          this.loading = false;
          return;
        }

        this.user.userType = this.userType;
        if (this.user.email && this.user.password) {
          this.$store.dispatch("auth/login", this.user).then(
            () => {

              if(this.userType == 'organization')
                this.$router.push("/organizations/index");
              else
                this.$router.push("/" + this.userType);

              this.$store.state.auth.user.userType = this.userType;
              this.$root.$emit("user-login");
            },
            (error) => {
              this.loading = false;
              this.message = error.response.data.message;
            }
          );
        } //user&pwd
      }); //valid
    }, //onSubmit
  }, //methods
};
</script>

<style scoped>
.login-outer-box {
  padding: 60px 30px 40px 20px;
  background: #f49537;
  border-radius: 10px;
}
.login-inner-box {
  padding: 30px;
  background: #212025;
  border-radius: 10px;
  color: #fff;
}
</style>
